import { IsavedExportSettingsDTO } from "../../bulkexport/api";

export enum FavouriteItemType {
  Slide = 1,
  Map = 2,
  BulkExport = 3,
  SavedBulkExport = 4,
}

interface FavouriteItemBase {
  id: number;
  date: string;
  type: FavouriteItemType;
  name: string;
}

export interface FavouriteSlideItem extends FavouriteItemBase {
  type: FavouriteItemType.Slide;
  mark: {
    id: number;
    reportId: string;
    parameters: Record<string, string[]>;
  };
}
export interface FavouriteMapItem extends FavouriteItemBase {
  type: FavouriteItemType.Map;
  mark: {
    id: number;
    parameters: Record<string, string[]>;
  };
}
export interface FavouriteBulkExportItem extends FavouriteItemBase {
  type: FavouriteItemType.BulkExport;
  mark: {
    id: number;
    parameters: IsavedExportSettingsDTO;
  };
}
export interface FavouriteSavedBulkExportItem extends FavouriteItemBase {
  type: FavouriteItemType.SavedBulkExport;
  mark: {
    id: number;
    parameters?: IsavedExportSettingsDTO;
    savedBulkExportSettingsId?: number;
  };
}

export type FavouriteItem = FavouriteSlideItem | FavouriteMapItem | FavouriteBulkExportItem | FavouriteSavedBulkExportItem;

interface FavouriteItemBaseDraft {
  type: FavouriteItemType;
  name: string;
  date?: string;
}

export interface FavouriteSlideItemDraft extends FavouriteItemBaseDraft {
  type: FavouriteItemType.Slide;
  mark: {
    reportId: string;
    parameters: Record<string, string[]>;
  };
}
export interface FavouriteMapItemDraft extends FavouriteItemBaseDraft {
  type: FavouriteItemType.Map;
  mark: {
    parameters: Record<string, string[]>;
  };
}
export interface FavouriteBulkExportItemDraft extends FavouriteItemBaseDraft {
  type: FavouriteItemType.BulkExport;
  mark: {
    parameters: IsavedExportSettingsDTO;
  };
}
export interface FavouriteSavedBulkExportItemDraft extends FavouriteItemBaseDraft {
  type: FavouriteItemType.SavedBulkExport;
  mark: {
    savedBulkExportSettingsId: number;
  }
}
export type FavouriteItemDraft =
  | FavouriteSlideItemDraft
  | FavouriteMapItemDraft
  | FavouriteBulkExportItemDraft
  | FavouriteSavedBulkExportItemDraft;
